<mat-nav-list>
    <a mat-list-item
       [routerLink]="['/', 'kuenstlersuche']">Künstler suchen</a>
    <a mat-list-item
       [routerLink]="['/', 'report']">Leistungen melden</a>
    <a mat-list-item
       [routerLink]="['/', 'user', 'edit-self']">Meine Daten ändern</a>
</mat-nav-list>